<template>
  <div class="main">
    <report-top>
      <template slot="search">
        <ly-search v-model="searchItem.keyword" @search="search"></ly-search>
      </template>
    </report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">单位筛选</p>
        <selectAlotGroup
          placement="left"
          @groupIdList="
            searchItem.groupIdList = $event;
            getList();
          "
        ></selectAlotGroup>
      </div>
      <div id="ddas">
        <Button @click="exportAll" icon="md-download">导出</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="fenpei(row, index)">分配</Button>
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button
          size="small"
          @click="del(row, index)"
          :disabled="row.useType != null"
          >删除</Button
        >
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="openForm"
      :title="isAdd ? '新增设备' : '编辑设备：' + item.deviceNo"
      footer-hide
      width="700"
      height="400"
      @on-cancel="cliclCancelBtn"
    >
      <Form ref="item" :model="item" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16">
          <Col span="12">
            <FormItem label="设备号" prop="deviceNo">
              <Input v-model="item.deviceNo" placeholder="请输入"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="sim卡号" prop="simNo">
              <Input v-model="item.simNo" placeholder="请输入"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="设备类型" prop="deviceModel">
              <Select v-model="item.model">
                <Option
                  v-for="x in deviceTypeList"
                  :value="x.name"
                  :key="x.name"
                  >{{ x.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="采购时间" prop="purchaseTime1">
              <DatePicker
                type="date"
                placeholder="请选择"
                v-model="item.purchaseTime1"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="品牌" prop="brand">
              <Input v-model="item.brand" placeholder="请输入"></Input>
            </FormItem>
          </Col>

          <Col span="12">
            <FormItem label="厂商" prop="firmName">
              <Input v-model="item.firmName" placeholder="请输入"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="设备别名" prop="name">
              <Input v-model="item.name" placeholder="请输入"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="备注" prop="remark">
              <Input
                type="textarea"
                v-model="item.remark"
                placeholder="请输入"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button @click="resetForm">重置表单</Button>
              <Button type="primary" @click="addUpdate('item')"
                >提交表单</Button
              >
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>

    <Drawer
      title="请选择物联网卡"
      placement="right"
      :closable="true"
      v-model="openIotcard"
      draggable
      class="my-drawer"
    >
      <iotCardList @iotCard="reIotCard" v-if="openIotcard"></iotCardList>
    </Drawer>

    <binecarperson ref="binecarperson" @value="bind"></binecarperson>
  </div>
</template>
<script>
import axios from "axios";
import iotCardList from "./iotCardList.vue";
import binecarperson from "./binecarperson.vue";

export default {
  components: { iotCardList, binecarperson },
  data() {
    return {
      openIotcard: false,
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "设备号",
          key: "deviceNo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "sim卡号",
          key: "simNo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "所属单位",
          key: "groupName",
          minWidth: 80,
          maxWidth: 200,
        },
        {
          title: "设备用途",
          key: "useType",
          render: (h, data) => {
            return h("div", this.$t("useType." + data.row.useType));
          },
          minWidth: 80,
          maxWidth: 200,
        },
        {
          title: "设备类型",
          key: "model",
          minWidth: 80,
          maxWidth: 200,
        },
        {
          title: "品牌",
          key: "brand",
          minWidth: 80,
          maxWidth: 200,
        },
        {
          title: "厂商",
          key: "firmName",
          minWidth: 80,
          maxWidth: 200,
        },
        {
          title: "采购时间",
          key: "purchaseTime2",
          minWidth: 80,
          maxWidth: 200,
        },
        {
          title: "设备别名",
          key: "name",
          minWidth: 80,
          maxWidth: 200,
        },
        {
          title: "备注名",
          key: "remark",
          minWidth: 80,
          maxWidth: 200,
        },
        {
          title: "创建者账号",
          key: "createAccount",
          minWidth: 80,
          maxWidth: 200,
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          minWidth: 80,
          maxWidth: 200,
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        deviceNo: "",
        groupId: "",
        groupName: "",
        simNo: "",
        model: "KM01", //型号（对应字典）
      },
      ruleValidate: {
        deviceNo: { required: true, message: "必填" },
        groupName: { required: true, message: "必填" },
        model: { required: true, message: "必填" },
        simNo: { required: true, message: "必填" },
      },
      deviceTypeList: [],
      searchItem: {
        groupIdList:[],
        keyword: "",
        pageSize: 50,
        pageNumber: 1,
      },
      total: 0,
      deviceNo: "",
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.dm + "/device/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (const i in data) {
          data[i].purchaseTime1 = this.utils.sjcTo(data[i].purchaseTime);
          data[i].purchaseTime2 = this.utils.time(
            data[i].purchaseTime,
            "yymmdd"
          );
        }
        this.tableData = data;
      });
    },
    exportAll() {
      var params = [
        {
          name: "keyword",
          value: this.searchItem.keyword,
        },
        {
          name: "groupIdList",
          value: this.searchItem.groupIdList,
        },
      ];
      this.utils.exportData(axios.dm + "/device/export", params);
    },
    addUpdate(name) {
      console.log(this.item);

      this.$refs[name].validate((valid) => {
        this.item.purchaseTime = this.utils.toSjc(this.item.purchaseTime1);
        if (valid) {
          if (this.isAdd) {
            axios({
              method: "post",
              url: axios.dm + "/device/add",
              data: this.item,
            }).then((res) => {
              console.log(res);
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          } else {
            axios({
              method: "post",
              url: axios.dm + "/device/update",
              data: this.item,
            }).then((res) => {
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          }
        }
      });
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.dm + "/device/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.openForm = false;
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.openForm = true;
      this.isAdd = false;
      this.item = row;
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    fenpei(v) {
      this.deviceNo = v.deviceNo;
      this.$refs.binecarperson.reachData(v);
    },
    bind(v) {
      console.log(v);
      this.$Modal.confirm({
        title: "是否将设备" + this.deviceNo + v.model + v.name,
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.dm + "/device/bind",
            data: v,
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    getDictionary() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: "/dictionary/item",
        data: {
          keyword: "deviceModel",
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.deviceTypeList = JSON.parse(res.data.data.value);
      });
    },

    search() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
    this.getDictionary();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/information/device.vue